export default __webpack_public_path__ + "static/media/address-book-sm.20e581a3.svg";